import { PriceTabButtonProps } from "../types/PriceTabTypes";

export const PriceTabButton: React.FC<PriceTabButtonProps> = ({
  onClick,
  icon,
  children,
  variant,
  disabled = false
}) => (
  <button
    className={`btn btn-soft-${variant} btn-sm`}
    onClick={onClick}
    disabled={disabled}
    aria-label={`${children}`}
  >
    <i className={`${icon} align-middle me-1`}></i> {children}
  </button>
);